import {
  SAVE_ATTORNEYINFO_STARTED,
  SAVE_ATTORNEYINFO_SUCESS,
  SAVE_ATTORNEYINFO_FAILED,
    GET_ATTORNEYINFO_STARTED,
    GET_ATTORNEYINFO_SUCESS,
    GET_ATTORNEYINFO_FAILED,
    UPDATE_ATTORNEYDETAILS_SUCCESS,
    UPDATE_ATTORNEYDETAILS_STARTED,
    UPDATE_ATTORNEYDETAILS_FAILED,

    SAVE_G28FORM_STARTED,
  SAVE_G28FORM_SUCESS,
  SAVE_G28FORM_FAILED,
    GET_G28FORM_STARTED,
    GET_G28FORM_SUCESS,
    GET_G28FORM_FAILED,
    UPDATE_G28FORM_SUCCESS,
    UPDATE_G28FORM_STARTED,
    UPDATE_G28FORM_FAILED,

    GENERATE_G28FORM_SUCCESS,
    GENERATE_G28FORM_STARTED,
    GENERATE_G28FORM_FAILED,

    
} from '../actions/AddAttorney';

const intialData= {
    status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
    },
    items: [],
    userInput: {       
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
    },
    isLoading: true,
    isFormSubmit: false,
    isLoggedIn: false,
    error: ''
};
export const attorneyData = (state = intialData, action: any) => {
  
 
    switch (action.type) {
        case SAVE_ATTORNEYINFO_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case SAVE_ATTORNEYINFO_SUCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case SAVE_ATTORNEYINFO_FAILED:
      return {
        ...state,
        isLoading: true,
      };
      case GET_ATTORNEYINFO_STARTED:  
     return {
       ...state,
       items:[],
       isLoading: true,
     };
   case GET_ATTORNEYINFO_SUCESS:
     return {
       ...state,
       isLoading: false,
       status: action.status,
       items: action.payload
     };
   case GET_ATTORNEYINFO_FAILED:
     return {
       ...state,
       isLoading: true,
     };
     case UPDATE_ATTORNEYDETAILS_STARTED:           
      return {
        ...state,
        items:[],
        isLoading: true,
      };
    case UPDATE_ATTORNEYDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: action.status,
        items: action.payload
      };
    case UPDATE_ATTORNEYDETAILS_FAILED:
      return {
        ...state,
        isLoading: true,
      };
 default:
    return state;
}

}


export const caseFlowg28Data = (state = intialData, action: any) => {
  
  
  switch (action.type) {
      case SAVE_G28FORM_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case SAVE_G28FORM_SUCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case SAVE_G28FORM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    case GET_G28FORM_STARTED:  
   return {
     ...state,
     items:[],
     isLoading: true,
   };
 case GET_G28FORM_SUCESS:
   return {
     ...state,
     isLoading: false,
     status: action.status,
     items: action.payload
   };
 case GET_G28FORM_FAILED:
   return {
     ...state,
     isLoading: true,
   };
   case UPDATE_G28FORM_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case UPDATE_G28FORM_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case UPDATE_G28FORM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
default:
  return state;
}

}


export const g28PdfGenerationNewData = (state = intialData, action: any) => {
  
 
  switch (action.type) {
      case GENERATE_G28FORM_STARTED:           
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GENERATE_G28FORM_SUCCESS:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GENERATE_G28FORM_FAILED:
    return {
      ...state,
      isLoading: true,
    };
   
default:
  return state;
}

}